import ip from 'app/forms/validations/ip';

// Try to use ipv4Port when possible
// Todo: possibly add port validation based on ipv4 or ipv6 and def add tests.  Response msg (CIDR + port) is suspect.
function fn(value) {
  if (value) {
    if (typeof value === 'string') {
      const portStripped = value.substr(0, value.lastIndexOf(':'));

      return ip.fn(value) ?? ip.fn(portStripped);
    }
    return ip.fn(value);
  }

  return true;
}

export default {
  message: 'Enter a valid IPv4 or IPv6 address. Port and/or CIDR/netmask is supported. ',
  fn
};
